module.exports = __webpack_public_path__ + "img/carrousel-rad-conv-mov-8.e5f40c7a.png";